import * as React from 'react';
import { Card, Col, Container, Image, Row } from 'react-bootstrap';


interface uspProp {
    image: string
    title: string
    text: string
}

export default function UniqueSellingPoint(prop: uspProp) {

    return (
        <Row className='usp-card d-flex align-items-center' xs={1} sm={1} md={2}>
            <Col className='usp-icon-text'>
                <Image src={prop.image} className='usp-image' />
                    <p className='usp-title'>{prop.title}</p>
            </Col>
            <Col className="usp-text" md={4}>
                {prop.text}
            </Col>
        </Row>
    )
}

